import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

import { ContainerWrapper } from '../../container_wrapper';

const useStyles = createUseStyles((theme) => ({
    container: {
        fontSize: theme.fontSize.sm,
        lineHeight: '1.8rem',
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey700
    }
}));

const ResultsPricesNoticeXs = ({ padding }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    return (
        <ContainerWrapper padding={padding} className={classNames('test-resultsPricesNotice-xs')}>
            <Typography className={classes.container}>
                {`${resultsPricesNoticeText} ${resultsPricesGSTText}`}
            </Typography>
        </ContainerWrapper>
    );
};

ResultsPricesNoticeXs.propTypes = {
    padding: PropTypes.array
};

const resultsPricesNoticeText = 'Just so you know, prices quoted may change based on factors like rounding and further questions asked by the insurer.';
const resultsPricesGSTText = 'Results are inclusive of GST & Govt. charges.';

export { ResultsPricesNoticeXs, resultsPricesNoticeText, resultsPricesGSTText };
